import styled from '@emotion/styled';
import NoHeaderPage from "components/layout/newOnboarding/NoLogInPage";
import { usePostSignup, usePostLogin, usePostKakaoToken } from "hooks/api";
import Balloon from "components/ui/Balloon";
import ReactGA from 'react-ga4';
import { useEffect, useState } from 'react';
import { authMakeCookieData } from 'hooks/util/makeCookie';
import { IkakaoLogin  } from 'common/interface/login';
import RandomString from 'hooks/util/randomString';
import PhotoContainer from './PhotoContainer';
import ReactPixel from 'react-facebook-pixel';
import Cookies from 'js-cookie';

const REST_API_KEY = process.env.REACT_APP_KAKAO_REST_API_KEY || "";

const Elem:React.FC<any> = () => {
  const gaId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;
  const REDIRECT_URI = process.env.REACT_APP_KAKAO_REDIRECT_URI || "";

  const handleKakaoLogin = async () => {
    const fbc = Cookies.get('_fbc') || "";
    ReactPixel.fbq('track', 'Lead', {
      "type": "webLogin",
      "fbc": fbc
    });

    if (gaId){
        ReactGA.event({
          "category" : "Button",
          "action": "Click",
          "label" : "Kakao Login Button"
        })
      }
    const scope =`phone_number`
    const KAKAO_AUTH_URL = 
    `https://kauth.kakao.com/oauth/authorize?response_type=code&client_id=${REST_API_KEY}&redirect_uri=${REDIRECT_URI}&prompt=login&scope=${scope}&auth_type=reauthenticate`
    window.location.href = KAKAO_AUTH_URL;
  };

  const handleAppStore = async () => {
    const fbc = Cookies.get('_fbc') || "";
    window.open("https://apps.apple.com/kr/app/%ED%8F%AC%ED%8B%B0%ED%8E%98%ED%83%80-%ED%94%84%EB%A6%AC%EB%AF%B8%EC%97%84-%EC%9D%B8%ED%99%94%EA%B5%AC%EB%8F%85/id1619040733", "_blank")
    ReactPixel.fbq('trackCustom', 'App_Up_AppInstall', {
      "content_name": 'App Install',
      "content_category": 'Mobile App',
      "fbc": fbc,
      "store": 'appStore',
      "city": "KR",
      "gender" : "female"
    })
    
    // await postLeadConversionAPI({ fbclid, source, medium, content, fbc })
  }

  const handleGoogle = async () => {
    const fbc = Cookies.get('_fbc') || "";
    window.open("https://play.google.com/store/apps/details?id=com.photypeta.photypetaApp", "_blank");
    ReactPixel.fbq('trackCustom', 'App_Up_AppInstall', {
      "content_name": 'App Install',
      "content_category": 'Mobile App',
      "fbc": fbc,
      "store": 'googlePlayStore',
      "city": "KR",
      "gender" : "female"
    })
  }

  return (
    <NoHeaderPage disable>
      <Container>
        <TextContainer>
          <SmallText className="top">지금 인화하세요!</SmallText>
          <TextBox className="top">
            <Text className="bigBold">가장 소중한 사진</Text>
            <Text className="bigBold">5장을 선택해주세요</Text>
            <SmallText className="middle">
              무료로 인화해 보내드려요
            </SmallText>
          </TextBox>
        </TextContainer>
        <CircleImgContainer>
          <PhotoContainer />
        </CircleImgContainer>
        <SmallText className="bottom"></SmallText>
        <Body>
          <LoginButton
            onClick={handleKakaoLogin}
          >
            <LoginImg>
              <Img
                src={"/images/kakaologin.png"}
              />
            </LoginImg>
            <KakaoWrapper>
              카카오로 계속하기
            </KakaoWrapper>
          </LoginButton>
          <LineContainer>
            <Line/>
            <LineText>또는</LineText>
            <Line/>
          </LineContainer>
          <SmallText className="bottom">앱에서 시작하기</SmallText>
          <DownloadButtonWrapper>
            <DownloadButton className="app"
              onClick={handleAppStore}
            >
            <LoginImg className="bottom">
              <Img
                src={"/images/newLanding/home/appstore.png"}
              />
              </LoginImg>
              <span>
                APP STORE
              </span>
              </DownloadButton>
            <DownloadButton className="google"
              onClick={handleGoogle}
            >
              <LoginImg className="bottom">
                <Img
                  src={"/images/newLanding/home/googleplay.png"}
                />
              </LoginImg>
              <span>
                GOOGLE PLAY
              </span>
            </DownloadButton>
          </DownloadButtonWrapper>
        </Body>
      </Container>
    </NoHeaderPage>
  )
}

export default Elem;

const Container = styled.div`
  width: 100%;
  /* height: 100%; */
  min-height: 85vh;
  display: flex;
  flex-direction: column;
  background-color: #F5F3EF;
  padding: 25px 17px;
`
const LoginImg = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 10px;

  &.bottom {
    margin-left: 20px;
  }
`;
const Img= styled.img`
  width: 100%;
  height: 100%;
`;

const CircleImgContainer = styled.div`
  width: 100%;
  margin: 35px auto;
`

const LoginButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60px;
  margin: 0 auto;
  border-radius: 50px;
  background-color: #f9e000;
  color: #000000;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
`
const KakaoWrapper = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 15px;
  color: #3C1E1E;
`;
const TextContainer = styled.div`
  /* margin-top: 32px; */
  /* margin-right: 90px; */
  display: flex;
  flex-direction: column;
`;
const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  &.top{}
  &.bottom{
    margin-top: 13px;
  }
`;
const Text = styled.div`
  &.bigNormal{
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 400;
    font-size: 34.7255px;
    line-height: 42px;
    letter-spacing: -0.03em;
    color: #101010;
  }
  &.bigBold {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    /* line-height: 42px; */
    letter-spacing: -0.03em;
    color: #101010;
  }
  &.normal {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 400;
    font-size: 16.3107px;
    line-height: 28px;
    /* or 173% */

    letter-spacing: -0.03em;

    color: #636363;
  }
`;
const Body= styled.div`
  width: 100%;
  /* min-height: 50vh; */
  display: flex;
  flex-direction: column;
  margin: 0px auto;
`;

const SmallText = styled.div`
  &.top {
    color: #141414;
    margin-bottom: 15px;
    font-weight: bold;
  }
  
  &.middle {
    margin-top: 16px;
    color: #545454;
    opacity: 0.6
  }

  &.bottom {
    margin: 30px auto 22px;
    color: #545454;
  }
`;

const DownloadButtonWrapper = styled.div`
  width: 100%;
  min-height: 100px;
  margin-bottom: 40px;
`

const DownloadButton = styled.button`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  border-radius: 30px;
  font-size: 13px;
  font-weight: 500;
  background-color: white;
  color: black;
  border: 1px solid #6F6F6F;
  padding-right: 50px;

  &.app{
    margin-right: 10px;
    margin-bottom: 20px;
  }

  &.google {}

  span {
    display: flex;
    margin: 0 auto;
  }
`;


const LineContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 40px 0px 0px;
`
const Line = styled.span`
  flex: 1;
  height: 1px;
  background-color: #D4D4D4; 
  /* 원하는 색상으로 변경 */
  margin: 0 10px; /* 텍스트와 선 사이의 간격 */
`;

const LineText = styled.span`
  white-space: nowrap; /* 텍스트가 줄 바꿈되지 않도록 */
  color: #D4D4D4;
`;